import {inject, Injectable} from '@angular/core';
import {WalletStatus, WalletStore} from '../store/wallet.store';

@Injectable({providedIn: 'root'})
export class CheckWalletLimitUseCase {
  private readonly store = inject(WalletStore);

  public execute(cartTotalAmount: number): void {
    const {wallet, status} = this.store.state();

    const walletBalance = wallet?.availableBalance ?? 0
    const isWalletActive = wallet && status === WalletStatus.ACTIVE

    if (isWalletActive && cartTotalAmount) {
      this.store.setHasReachedLimit(cartTotalAmount > walletBalance);
    }
  }
}
